export default __webpack_public_path__ + "static/media/pentagons-no-1.4d62366c.mid";